import { useParams } from 'react-router-dom';
import { Box, Container, Grid, Typography, Divider, Rating } from '@mui/material';
import ProductImageGallery from '../components/products/ProductImageGallery';


const products = [
  {
    id: 1,
    name: "Silla Moderna",
    price: "120,000",
    description: "Esta silla de diseño contemporáneo combina elegancia y comodidad. Fabricada con materiales sostenibles y ergonómicos para garantizar máximo confort.",
    images: [
      "/images/product1.jpg",
      "/images/product1-alt1.jpg",
      "/images/product1-alt2.jpg"
    ],
    rating: 4.5,
    reviewCount: 24,
    details: "Materiales: Madera de teca sostenible y tejido ecológico. Dimensiones: 50cm x 50cm x 80cm. Peso: 8kg. Color: Natural."
  },
  // Agrega más productos según sea necesario
];

const ProductDetail = () => {
  const { id } = useParams();
  const product = products.find(p => p.id === parseInt(id));

  if (!product) return <div>Producto no encontrado</div>;

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <ProductImageGallery images={product.images} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h3" component="h1" gutterBottom>
            {product.name}
          </Typography>
          
          <Box display="flex" alignItems="center" mb={2}>
            <Rating value={product.rating} precision={0.5} readOnly />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
              ({product.reviewCount} reseñas)
            </Typography>
          </Box>
          
          <Typography variant="h4" color="primary" gutterBottom>
            ₡{product.price}
          </Typography>
          
          <Typography variant="body1" paragraph>
            {product.description}
          </Typography>
          
          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h5" gutterBottom>
            Detalles del producto
          </Typography>
          <Typography variant="body1" paragraph>
            {product.details}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ProductDetail;